<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">
                <ol class="breadcrumb noprint">
                    <li>
                        <a :href="'#/'">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active"> <i class="fa fa-suitcase" aria-hidden="true"></i> ONUS PARA ATIVAR</li>
                </ol>
                <div class="row" v-if="contratos && contratos.onus && ! registrar">

                    <div class="col-md-4" style="margin-top: 10px">
                        <button class="btn-sm btn btn-success" @click="loadUnregistered()">
                            ATUALIZAR LISTAGEM
                        </button>
                    </div>

                    <div class="col-md-8">
                        <blockquote class="blockquote-reverse">
                            Total de ONUs para ativar: <b>{{ contratos.onus.length }}</b>
                        </blockquote>
                    </div>

                    <div class="col-md-12" style="margin-top: 20px">

                        <table id="mytable" class="table table-bordred ">

                            <thead>
                                <tr>
                                    <th style="width: 150px">MAC</th>
                                    <th style="width: 50px" class="text-center">SLOT</th>
                                    <th style="width: 50px" class="text-center">PON</th>
                                    <th>MODELO</th>
                                    <th style="text-align: center;width: 140px" class="noprint">AÇÕES</th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="r in contratos.onus" v-bind:key="r.mac">
                                    <td>
                                        <b>{{ r.mac }}</b>
                                    </td>
                                    <td class="text-center">
                                        <b>{{ r.slot }}</b>
                                    </td>
                                    <td class="text-center">
                                        <b>{{ r.pon }}</b>
                                    </td>
                                    <td>
                                        <b>{{ r.modelo }}</b>
                                    </td>
                                    <td class="noprint text-center">
                                        <a @click="registrar = r" class="btn btn-primary btn-xs">
                                            REGISTRAR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                        </a>
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>
                <div class="row" v-else-if="registrar">
                    <div class="col-md-12">

                        <form class="form-horizontal" >

                            <div class="panel panel-info">
                                <div class="panel-heading">ONU</div>
                                <div class="panel-body" >

                                    <div class="form-group">
                                        <div class="col-sm-4">
                                            <label for="mac" class="control-label">MAC</label>
                                            <input disabled :value="registrar.mac" class="form-control" id="mac">
                                        </div>

                                        <div class="col-sm-4">
                                            <label for="modelo" class="control-label">MODELO</label>
                                            <input disabled :value="registrar.modelo" class="form-control" id="modelo">
                                        </div>

                                        <div class="col-sm-2">
                                            <label for="slot" class="control-label">SLOT</label>
                                            <input disabled :value="registrar.slot" class="form-control" id="slot">
                                        </div>

                                        <div class="col-sm-2">
                                            <label for="pon" class="control-label">PON</label>
                                            <input disabled :value="registrar.pon" class="form-control" id="pon">
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="col-sm-4">
                                            <label for="_id" class="control-label">PAC PON</label>
                                            <select v-model="registrar._id" class="form-control" id="_id">
                                                <option v-for="pac in pacpons" :value="pac._id" v-bind:key="pac._id">{{pac.nome}}</option>
                                            </select>
                                        </div>

                                        <div class="col-sm-2">
                                            <label for="fabricante" class="control-label">FABRICANTE</label>
                                            <select class="form-control" id="fabricante" v-model="registrar.fabricante">
                                                <option value="INTELBRAS">INTELBRAS</option>
                                                <option value="MIKROTIK">MIKROTIK</option>
                                                <option value="FIBERHOME">FIBERHOME</option>
                                            </select>
                                        </div>

                                        <div class="col-sm-2" v-if="registrar.loid">
                                            <label for="loid" class="control-label">LOID</label>
                                            <input disabled :value="registrar.loid" class="form-control" id="loid">
                                        </div>

                                        <div class="col-sm-2" v-if="registrar.pwd">
                                            <label for="pwd" class="control-label">PWD</label>
                                            <input disabled :value="registrar.pwd" class="form-control" id="pwd">
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <button :disabled="!registrar._id || ! registrar.fabricante" type="button" @click="register()" class="btn btn-success">
                                REGISTRAR ONU
                            </button>

                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Fiberhome } from "../../class/fiberhome";
import { CaixaPacPon } from "../../class/index";
// TPLG0e596f97
export default {
    data() {
        return {
            contratos: [],
            pacpons: [],
            registrar: null,
            user: null,
            nome: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadUnregistered();
        this.loadPacPons();
    },
    methods: {
        async loadUnregistered() {
            if (!navigator.onLine) {
                return alert("NAVEGADOR OFFLINE");
            }
            this.contratos = await Fiberhome.unregistered();
        },
        async loadPacPons() {
            this.pacpons = await CaixaPacPon.allSemOnuMac();
        },
        async register() {
            if (!this.registrar.fabricante) {
                return alert("Informe o Fabricante!");
            }
            await Fiberhome.register(this.registrar);
            this.registrar = null;
            this.loadPacPons();
            this.loadUnregistered();
        },
        print() {
            window.print();
        }
    }
};
</script>
